import InsufficientCreditsModal from "./InsufficientCreditsModal";
import SubscriptionLapsedModal from "./SubscriptionLapsedModal";
import StorageCapModal from "./StorageCapModal";
import EmailNotVerifiedModal from "./EmailNotVerifiedModal";

// Mount this once per authenticated layout. Each modal subscribes to the
// wallet event bus on mount and surfaces itself when its event fires.
// They render nothing until triggered, so it's safe to keep them mounted.
export default function WalletModalsHost() {
  return (
    <>
      <InsufficientCreditsModal />
      <SubscriptionLapsedModal />
      <StorageCapModal />
      <EmailNotVerifiedModal />
    </>
  );
}
